import { useEffect, useState } from "react";

// 공용 관리자 사이드바.
// 데스크톱: 좌측 고정 220px
// 모바일(<=1023px): 햄버거 버튼 → 좌측에서 슬라이드되는 드로어 + 백드롭
//
// props:
//   active: 'queue' | 'refunds' | 'free-grants' | 'archive' | 'parents' | 'stats'
//   onSignOut: () => void
//   extraBadge?: ReactNode  (분석 큐 배지 등 — 옵션)
export default function AdminSidebar({ active, onSignOut, extraBadge }) {
  const [open, setOpen] = useState(false);

  // 라우트 이동 시 드로어 자동 닫기
  useEffect(() => {
    const close = () => setOpen(false);
    window.addEventListener("hashchange", close);
    return () => window.removeEventListener("hashchange", close);
  }, []);

  // 드로어 열렸을 때 ESC로 닫기 + body 스크롤 잠금
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === "Escape") setOpen(false); };
    document.addEventListener("keydown", onKey);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [open]);

  const isActive = (key) => active === key;

  return (
    <>
      {/* 모바일 햄버거 — CSS가 데스크톱에선 숨김 */}
      <button
        className="admin-hamburger"
        aria-label="메뉴 열기"
        onClick={() => setOpen(true)}
        type="button"
      >
        <span/><span/><span/>
      </button>

      {/* 백드롭 */}
      {open && (
        <div className="admin-drawer-backdrop" onClick={() => setOpen(false)}/>
      )}

      <aside className={"admin-side" + (open ? " is-open" : "")}>
        <div className="brand" style={{display:'flex',alignItems:'center',justifyContent:'space-between',gap:8}}>
          <span>
            <span className="mark">📖</span>i-talk{" "}
            <span style={{fontWeight:500,color:'rgba(255,255,255,.5)',fontSize:11,marginLeft:4}}>ops</span>
          </span>
          <button
            className="admin-drawer-close"
            aria-label="메뉴 닫기"
            onClick={() => setOpen(false)}
            type="button"
          >✕</button>
        </div>
        <nav>
          <a href="#admin" className={isActive("queue") ? "active" : undefined}>
            📥 분석 큐
            {extraBadge}
          </a>
          <a href="#admin/refunds" className={isActive("refunds") ? "active" : undefined}>
            💸 환불
          </a>
          <a href="#admin/free-grants" className={isActive("free-grants") ? "active" : undefined}>
            🎁 무료권 지급
          </a>
          <a href="#admin/archive" className={isActive("archive") ? "active" : undefined}>
            📚 리포트 아카이브
          </a>
          <a href="#admin/parents" className={isActive("parents") ? "active" : undefined}>
            👥 보호자
          </a>
          <a href="#admin/stats" className={isActive("stats") ? "active" : undefined}>
            📊 통계
          </a>
        </nav>
        <div style={{padding:'14px 22px',borderTop:'1px solid rgba(255,255,255,.08)'}}>
          <div style={{display:'flex',alignItems:'center',gap:10}}>
            <img src="/assets/character_doctor.png" alt="" style={{width:32,height:32,borderRadius:16,objectFit:'cover'}}/>
            <div style={{flex:1,minWidth:0}}>
              <div style={{fontSize:12,fontWeight:700}}>짱샘</div>
              <div style={{fontSize:10,color:'rgba(255,255,255,.5)'}}>소아물리치료사</div>
            </div>
            {onSignOut && (
              <button
                onClick={onSignOut}
                title="로그아웃"
                style={{
                  background:'transparent',border:'1px solid rgba(255,255,255,.15)',
                  color:'rgba(255,255,255,.6)',borderRadius:8,
                  padding:'6px 8px',fontSize:11,fontWeight:700,cursor:'pointer',fontFamily:'inherit',
                }}>
                ↩
              </button>
            )}
          </div>
        </div>
      </aside>
    </>
  );
}
